// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LitqMJBCCSjzXudOHTqq {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 1.5rem;
    --c-border: #dce0e6;
    --c-card: #f7f8fa;
    --c-muted: #6b7280;
    --c-text: #1f2933;
    --c-fail: #c2362f;
    --c-warn: #b87503;
    --c-success: #2f9e6f;
    margin-bottom: 3rem;
}

.Ej2TOKcp_U1co7Y8M4Im {
    font-size: 0.6875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--c-muted);
}

/* Top recommendation banner */

.fuKsgoif7pLnc7gTfjrg {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem 2.5rem;
    padding: 1.5rem;
    border: 1px solid var(--c-border);
    border-left: 5px solid var(--c-muted);
    border-radius: 0.75rem;
    background: var(--c-card);
}

.AXWKQ9n7xXIaP9pKGGCY {
    border-left-color: var(--c-fail);
}

.Cr0lSrPy1svhk_Rh97t7 {
    border-left-color: var(--c-warn);
}

.U4OGDZWS4unkzChVAGLW {
    border-left-color: var(--c-success);
}

.clU_zzD8UzL3AjQ7eQdU {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.XRr81da8apVLHLxMc9DJ {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.t5MAbuO8UuuI7TJgHZ1L {
    font-size: 1.625rem;
    font-weight: 700;
    line-height: 1.15;
    color: var(--c-text);
}

.X589eDCY6GEFyKqTX4ZW {
    color: var(--c-fail);
}

.DyCDzIUtyDP2r3Q6Hx6p {
    color: var(--c-warn);
}

.BbmlsaGi_Aq5FV29Wwm1 {
    color: var(--c-success);
}

.E_jqzRZQlpnkdz3B1lUb {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.25rem 0.625rem;
}

.tSfroMdvBR3ol0viJcqv {
    font-size: 0.875rem;
    color: var(--c-muted);
}

.QvAqKc6_nDjhmAs7DrDz {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    color: var(--c-muted);
    font-size: 0.8125rem;
    text-align: right;
}

/* Section headers */

.Or9OTrwPScwe3m3cXKd5 {
    margin: 0 0 0.25rem;
}

.ZD7tDUtURYD8PZath7a7 {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.YiluPKKWQdSVj4TeYhpA {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
}

.OzY4W0oIaaCUt0icWXNj {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    gap: 1.75rem 2.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid var(--c-border);
}

.nU4vkJcrcBmaH7T4ntTi {
    margin: 0 0 0.25rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--c-border);
    font-size: 0.8125rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--c-muted);
}

/* Headline stat tiles */

.Zx1vEjXP9BMPepjqKPxv {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.AYTrlkEIU13Ff8KVAW19 {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    flex: 0 1 12rem;
    min-width: 9rem;
    padding: 1rem 1.25rem;
    border: 1px solid var(--c-border);
    border-radius: 0.75rem;
    background: var(--c-card);
}

.zA8tuwpJwd1GdNNfqZzm {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
    color: var(--c-text);
}

.nY4hu3xPLbOf47MTayUX {
    color: var(--c-warn);
}

.IdZM3mvmlUUSlp1VxU_S {
    color: var(--c-fail);
}

.H9zzVz_x0IKsQWD688rn {
    color: var(--c-success);
}

/* Value + warning flag pairing inside detail grids */

.ErgXFgs5v3bZUnMn1NjF {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

/* Classifications */

.g5NDl7zkPLAJvFRZWEjg {
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
    padding: 1.125rem 1.25rem;
    border: 1px solid var(--c-border);
    border-radius: 0.75rem;
}

.fEVBnMczASAZiCuCkRkH {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem 0.875rem;
}

.KMLMhhdSkzwncYWvzquH {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
}

.fwX4ecQwcVWDc64bK46A {
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.2;
    color: var(--c-text);
}

.wP8y6Ps0Qx4CVDtATnNl {
    font-family: monospace;
    font-size: 0.75rem;
    color: var(--c-muted);
}

.LGrSLgddSZeTKrB2wdHP {
    color: var(--c-muted);
    font-size: 0.875rem;
}

.qB2eeani6S1KcdmUeaAa {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.6875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--c-muted);
}

.mA_woYeG21nfj8246NzW {
    font-size: 0.8125rem;
    color: var(--c-muted);
    cursor: pointer;
}

._ucIoJ_nv8G_5obqIe8m {
    font-family: monospace;
    font-size: 0.75rem;
    overflow-x: auto;
    overflow-y: auto;
    max-height: 12rem;
    margin: 0.5rem 0 0;
}

/* States */

.cvUXBOjHbYlMCY_Wejtd {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem 0;
}

.XKWkh7E9xU_OwVzJTzM6 {
    align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./pages/Devices/DeviceDetails/Diagnostics/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA,oBAAoB;;AAEpB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,wCAAwC;IACxC,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,iCAAiC;IACjC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,qDAAqD;;AAErD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".panel {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    margin-top: 1.5rem;\n    --c-border: #dce0e6;\n    --c-card: #f7f8fa;\n    --c-muted: #6b7280;\n    --c-text: #1f2933;\n    --c-fail: #c2362f;\n    --c-warn: #b87503;\n    --c-success: #2f9e6f;\n    margin-bottom: 3rem;\n}\n\n.eyebrow {\n    font-size: 0.6875rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--c-muted);\n}\n\n/* Top recommendation banner */\n\n.recommendation {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem 2.5rem;\n    padding: 1.5rem;\n    border: 1px solid var(--c-border);\n    border-left: 5px solid var(--c-muted);\n    border-radius: 0.75rem;\n    background: var(--c-card);\n}\n\n.recommendationFail {\n    border-left-color: var(--c-fail);\n}\n\n.recommendationWarn {\n    border-left-color: var(--c-warn);\n}\n\n.recommendationSuccess {\n    border-left-color: var(--c-success);\n}\n\n.dispositionBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.headlineItem {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.headlineValue {\n    font-size: 1.625rem;\n    font-weight: 700;\n    line-height: 1.15;\n    color: var(--c-text);\n}\n\n.dispositionValueFail {\n    color: var(--c-fail);\n}\n\n.dispositionValueWarn {\n    color: var(--c-warn);\n}\n\n.dispositionValueSuccess {\n    color: var(--c-success);\n}\n\n.reasonLine {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 0.25rem 0.625rem;\n}\n\n.reasonMeta {\n    font-size: 0.875rem;\n    color: var(--c-muted);\n}\n\n.meta {\n    display: flex;\n    flex-direction: column;\n    gap: 0.125rem;\n    color: var(--c-muted);\n    font-size: 0.8125rem;\n    text-align: right;\n}\n\n/* Section headers */\n\n.sectionTitle {\n    margin: 0 0 0.25rem;\n}\n\n.section {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.subSection {\n    display: flex;\n    flex-direction: column;\n    gap: 0.625rem;\n}\n\n.groupGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n    gap: 1.75rem 2.5rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid var(--c-border);\n}\n\n.groupHeading {\n    margin: 0 0 0.25rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid var(--c-border);\n    font-size: 0.8125rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--c-muted);\n}\n\n/* Headline stat tiles */\n\n.tiles {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.tile {\n    display: flex;\n    flex-direction: column;\n    gap: 0.375rem;\n    flex: 0 1 12rem;\n    min-width: 9rem;\n    padding: 1rem 1.25rem;\n    border: 1px solid var(--c-border);\n    border-radius: 0.75rem;\n    background: var(--c-card);\n}\n\n.tileValue {\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: 1;\n    color: var(--c-text);\n}\n\n.tileValueWarn {\n    color: var(--c-warn);\n}\n\n.tileValueFail {\n    color: var(--c-fail);\n}\n\n.tileValueSuccess {\n    color: var(--c-success);\n}\n\n/* Value + warning flag pairing inside detail grids */\n\n.valueWithFlag {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n}\n\n/* Classifications */\n\n.classificationCard {\n    display: flex;\n    flex-direction: column;\n    gap: 0.875rem;\n    padding: 1.125rem 1.25rem;\n    border: 1px solid var(--c-border);\n    border-radius: 0.75rem;\n}\n\n.classificationHeader {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem 0.875rem;\n}\n\n.classificationTitle {\n    display: flex;\n    flex-direction: column;\n    gap: 0.125rem;\n}\n\n.classificationPattern {\n    font-weight: 700;\n    font-size: 1.125rem;\n    line-height: 1.2;\n    color: var(--c-text);\n}\n\n.classificationToken {\n    font-family: monospace;\n    font-size: 0.75rem;\n    color: var(--c-muted);\n}\n\n.classificationDisposition {\n    color: var(--c-muted);\n    font-size: 0.875rem;\n}\n\n.evidenceLabel {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--c-muted);\n}\n\n.rawToggle {\n    font-size: 0.8125rem;\n    color: var(--c-muted);\n    cursor: pointer;\n}\n\n.evidence {\n    font-family: monospace;\n    font-size: 0.75rem;\n    overflow-x: auto;\n    overflow-y: auto;\n    max-height: 12rem;\n    margin: 0.5rem 0 0;\n}\n\n/* States */\n\n.unavailableBanner {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n    padding: 1rem 0;\n}\n\n.refresh {\n    align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
export var panel = `LitqMJBCCSjzXudOHTqq`;
export var eyebrow = `Ej2TOKcp_U1co7Y8M4Im`;
export var recommendation = `fuKsgoif7pLnc7gTfjrg`;
export var recommendationFail = `AXWKQ9n7xXIaP9pKGGCY`;
export var recommendationWarn = `Cr0lSrPy1svhk_Rh97t7`;
export var recommendationSuccess = `U4OGDZWS4unkzChVAGLW`;
export var dispositionBlock = `clU_zzD8UzL3AjQ7eQdU`;
export var headlineItem = `XRr81da8apVLHLxMc9DJ`;
export var headlineValue = `t5MAbuO8UuuI7TJgHZ1L`;
export var dispositionValueFail = `X589eDCY6GEFyKqTX4ZW`;
export var dispositionValueWarn = `DyCDzIUtyDP2r3Q6Hx6p`;
export var dispositionValueSuccess = `BbmlsaGi_Aq5FV29Wwm1`;
export var reasonLine = `E_jqzRZQlpnkdz3B1lUb`;
export var reasonMeta = `tSfroMdvBR3ol0viJcqv`;
export var meta = `QvAqKc6_nDjhmAs7DrDz`;
export var sectionTitle = `Or9OTrwPScwe3m3cXKd5`;
export var section = `ZD7tDUtURYD8PZath7a7`;
export var subSection = `YiluPKKWQdSVj4TeYhpA`;
export var groupGrid = `OzY4W0oIaaCUt0icWXNj`;
export var groupHeading = `nU4vkJcrcBmaH7T4ntTi`;
export var tiles = `Zx1vEjXP9BMPepjqKPxv`;
export var tile = `AYTrlkEIU13Ff8KVAW19`;
export var tileValue = `zA8tuwpJwd1GdNNfqZzm`;
export var tileValueWarn = `nY4hu3xPLbOf47MTayUX`;
export var tileValueFail = `IdZM3mvmlUUSlp1VxU_S`;
export var tileValueSuccess = `H9zzVz_x0IKsQWD688rn`;
export var valueWithFlag = `ErgXFgs5v3bZUnMn1NjF`;
export var classificationCard = `g5NDl7zkPLAJvFRZWEjg`;
export var classificationHeader = `fEVBnMczASAZiCuCkRkH`;
export var classificationTitle = `KMLMhhdSkzwncYWvzquH`;
export var classificationPattern = `fwX4ecQwcVWDc64bK46A`;
export var classificationToken = `wP8y6Ps0Qx4CVDtATnNl`;
export var classificationDisposition = `LGrSLgddSZeTKrB2wdHP`;
export var evidenceLabel = `qB2eeani6S1KcdmUeaAa`;
export var rawToggle = `mA_woYeG21nfj8246NzW`;
export var evidence = `_ucIoJ_nv8G_5obqIe8m`;
export var unavailableBanner = `cvUXBOjHbYlMCY_Wejtd`;
export var refresh = `XKWkh7E9xU_OwVzJTzM6`;
export default ___CSS_LOADER_EXPORT___;
